/* begin POCH */
/*document.addEventListener("DOMContentLoaded", () => {
  console.log("Hello World!");
  let seachButtonMobile = document.getElementById('button-search-mobile');
  const mobileSearchBar = document.getElementById('mobile-search-bar');
  seachButtonMobile.onclick = function() {
  }
});*/
(function ($) {
  $(document).ready(function() {
    let $mobileSearchButton = $('.button__search');
    let $mobileSearchBar = $('.mobile-search-bar');
    let $mobileSearchClose = $('.mobile-search-close');
    
    let $desktopSearchButton = $('.button--search');
    let $desktopSearchBar = $('.desktop-search-bar');
    let $desktopSearchClose = $('.desktop-search-close');
    
    $mobileSearchButton.bind('click', () => {
      $mobileSearchBar.toggleClass('d-block');
      // $mobileSearchBar.find('input[type=search]').focus();
    });

    $mobileSearchClose.bind('click', () => {
      $mobileSearchBar.removeClass('d-block');
    });
    
    $desktopSearchButton.bind('click', () => {
      $desktopSearchBar.toggleClass('d-grid');
      // $mobileSearchBar.find('input[type=search]').focus();
    });

    $desktopSearchClose.bind('click', () => {
      $desktopSearchBar.removeClass('d-grid');
    });

    $('.recipe--ingredients > ul > li input').each(function() {
      $(this).bind('click', () => {
        $(this).parent().parent('li').toggleClass('ingredient--checked');
      });
    });

    var noSleep = new NoSleep();

    var wakeLockEnabled = false;
    var toggleEl = document.querySelector("#recipe--cook-mode-toggle");
    if ( toggleEl !== null ) {
      toggleEl.addEventListener('click', function() {
        if (!wakeLockEnabled) {
          noSleep.enable(); // keep the screen on!
          wakeLockEnabled = true;
          toggleEl.value = "Cook Mode (enabled)";
          /*document.body.style.backgroundColor = "green";*/
        } else {
          noSleep.disable(); // let the screen turn off.
          wakeLockEnabled = false;
          toggleEl.value = "Cook Mode (disabled)";
          /*document.body.style.backgroundColor = "";*/
        }
      }, false);
    }
  });
})(jQuery);
/* end POCH */